// extracted by mini-css-extract-plugin
export default {"container":"FactoryScada_container__ltm4w"};